import webViewEventService from "@/services/webViewEvents/webViewEventService";

export const isWebView = !!window?.webview;
export const webViewToken = window?.token || "";
export const isWebViewEvents = !!window?.webviewEvents;
export const webViewVersion = webViewEventService.getWebViewVersion();
export const isIosWebView = isWebView;
